<template>
	<div v-if="person">
		<v-row justify="start">
			<!-- Salary -->
			<v-col cols="12" md="6" v-if="userProfile.role != 'person'">
				<v-text-field
					v-model="person.salary"
					outlined
					dense
					filled
					type="number"
					label="Salario por hora"
					:error-messages="salaryErrors"
					@input="$v.person.salary.$touch()"
					@blur="$v.person.salary.$touch()"
				></v-text-field>
			</v-col>
			<!-- appointment -->
			<v-col cols="12" md="6" justify="start">
				<v-text-field
					v-model="person.appointment"
					:disabled="disableEdit || userProfile.role == 'person'"
					outlined
					dense
					filled
					label="Cargo"
				></v-text-field>
			</v-col>
		</v-row>
		<v-divider></v-divider>
		<v-row>
			<v-col cols="12" sm="6" md="4" v-for="(day, i) in days" :key="day">
				<v-menu
					:ref="'menuStart' + i"
					v-model="menuStart[i]"
					:close-on-content-click="false"
					:nudge-right="40"
					:return-value.sync="person.start[i]"
					transition="scale-transition"
					offset-y
					max-width="290px"
					min-width="290px"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							v-model="person.start[i]"
							outlined
							dense
							class="ma-2"
							:disabled="userProfile.role == 'person'"
							:label="`Hora de ingreso ${day}`"
							prepend-icon="mdi-clock-time-four-outline"
							readonly
							hide-details
							v-bind="attrs"
							clearable
							v-on="on"
						></v-text-field>
					</template>
					<v-time-picker
						v-if="menuStart[i]"
						v-model="person.start[i]"
						full-width
						format="24hr"
						@click:minute="$refs['menuStart' + i][0].save(person.start[i])"
					></v-time-picker>
				</v-menu>
				<v-menu
					:ref="'menuEnd' + i"
					v-model="menuEnd[i]"
					:close-on-content-click="false"
					:nudge-right="40"
					:return-value.sync="person.end[i]"
					transition="scale-transition"
					offset-y
					max-width="290px"
					min-width="290px"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							v-model="person.end[i]"
							outlined
							dense
							:disabled="userProfile.role == 'person'"
							class="ma-2"
							:label="`Hora de salida ${day}`"
							prepend-icon="mdi-clock-time-four-outline"
							readonly
							clearable
							hide-details
							v-bind="attrs"
							v-on="on"
						></v-text-field>
					</template>
					<v-time-picker
						v-if="menuEnd[i]"
						v-model="person.end[i]"
						full-width
						format="24hr"
						@click:minute="$refs['menuEnd' + i][0].save(person.end[i])"
					></v-time-picker>
				</v-menu>
				<v-text-field
					:label="`Descuento minutos`"
					v-model="person.discount[i]"
					type="number"
					:disabled="userProfile.role === 'person'"
				></v-text-field>
				<v-btn
					v-if="userProfile.role == 'admin' || userProfile.role == 'superUser'"
					text
					x-small
					class="text-capitalize"
					@click="setAllDays(person.start[i], person.end[i], person.discount[i])"
				>
					Establecer este horario todos los dias
				</v-btn>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12">
				<v-btn
					:loading="loading"
					block
					small
					color="success"
					@click="submit"
					:disabled="!hasChangeForm"
				>
					Guardar
				</v-btn>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import { isEqual, cloneDeep } from 'lodash';
import { validationMixin } from 'vuelidate';
import { numeric } from 'vuelidate/lib/validators';

export default {
	props: {
		disableEdit: { type: Boolean, default: false },
		personProps: {
			type: Object,
			required: true,
		},
	},
	mixins: [validationMixin],
	data() {
		return {
			days: ['Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado', 'Domingo'],
			menuStart: [],
			menuEnd: [],
			loading: false,
			person: null,
			discount: [null, null, null, null, null, null, null],
		};
	},
	computed: {
		salaryErrors() {
			const errors = [];
			if (!this.$v.person.salary.$dirty) return errors;
			!this.$v.person.salary.numeric && errors.push('Solo se permiten numeros');
			return errors;
		},
		hasChangeForm() {
			return !isEqual(this.personProps, this.person, this.discount);
		},
	},
	mounted() {
		this.person = cloneDeep(this.personProps);
		this.setDefaultDays();
	},
	methods: {
		setDefaultDays() {
			if (!this.personProps.end.length && !this.personProps.start.length) {
				this.person.start = [null, null, null, null, null, null, null];
				this.person.end = [null, null, null, null, null, null, null];
			}
		},
		setAllDays(start, end, discount) {
			this.person.start = [start, start, start, start, start, start, start];
			this.person.end = [end, end, end, end, end, end, end];
			this.person.discount = [
				discount,
				discount,
				discount,
				discount,
				discount,
				discount,
				discount,
			];
		},
		async submit() {
			this.$v.$touch();
			if (!this.$v.$invalid && this.hasChangeForm) {
				this.loading = true;
				await this.putPerson({ ...this.person });
				this.loading = false;
			}
		},
		...mapActions({
			putPerson: 'Person/putPerson',
		}),
	},
	validations: {
		person: {
			salary: {
				numeric,
			},
		},
	},
	watch: {
		personProps() {
			this.person = cloneDeep(this.personProps);
			this.setDefaultDays();
		},
	},
};
</script>
